/** Bound read-only work and stop observing stale results after cancellation. */
export function withDeadline<T>(
  work: (signal: AbortSignal) => Promise<T>,
  message: string,
  signal?: AbortSignal,
  timeoutMs = 20_000,
): Promise<T> {
  const controller = new AbortController();
  return new Promise<T>((resolve, reject) => {
    const abort = () => {
      cleanup();
      controller.abort();
      reject(new DOMException("Cancelled", "AbortError"));
    };
    const timer = setTimeout(() => {
      cleanup();
      controller.abort();
      reject(new Error(message));
    }, timeoutMs);
    const cleanup = () => {
      clearTimeout(timer);
      signal?.removeEventListener("abort", abort);
    };
    if (signal?.aborted) {
      cleanup();
      abort();
      return;
    }
    signal?.addEventListener("abort", abort, { once: true });
    Promise.resolve()
      .then(() => work(controller.signal))
      .then(
        (value) => {
          cleanup();
          resolve(value);
        },
        (error) => {
          cleanup();
          reject(error);
        },
      );
  });
}
